module.exports = __webpack_public_path__ + "COBRA - Benefits During a Leave of Absence Guide.pdf";